import { Product } from 'lib/enums';
import MadlibOverride from 'routes/placeScroll/NoticeContentStep/MadlibOverride';
import MadlibOverrideAlert from 'routes/placeScroll/NoticeContentStep/MadlibOverrideAlert';

type MadlibInfoProps = {
  isOverrideActive: boolean;
  product: Product;
  isPublisher: boolean;
  onDisableMadlib: () => void;
};

function MadlibInfo({
  isOverrideActive,
  product,
  isPublisher,
  onDisableMadlib
}: MadlibInfoProps) {
  if (isOverrideActive) {
    return <MadlibOverrideAlert product={product} isPublisher={isPublisher} />;
  }

  if (isPublisher) {
    return <MadlibOverride product={product} onClick={onDisableMadlib} />;
  }

  return <></>;
}

export default MadlibInfo;
